"use client";

import React, { useRef, ReactNode, FC, CSSProperties } from "react";
import { useScroll } from "./use-scroll";
import { LeftOutlined, RightOutlined } from "@ant-design/icons";

import styles from "./scrollable-container.module.css";

type Props = {
  children: ReactNode;
  shouldShowArrow?: boolean;
  style?: CSSProperties
};

const ScrollableContainer: FC<Props> = ({
  children,
  shouldShowArrow = true,
  style: containerStyle,
}) => {
  const containerRef = useRef(null);
  const contentRef = useRef(null);

  const { arrowsVisible, handleScroll, scroll } = useScroll(
    containerRef,
    contentRef,
  );

  return (
    <div className={styles.containerScrollable} style={containerStyle}>
      {arrowsVisible.left && shouldShowArrow && (
        <button
          className={`${styles.scrollButton} ${styles.left}`}
          onClick={() => scroll("left")}
        >
          <LeftOutlined />
        </button>
      )}
      <div
        className={styles.scrollableItems}
        onScroll={handleScroll}
        ref={containerRef}
      >
        <div ref={contentRef}>{children}</div>
      </div>
      {arrowsVisible.right && shouldShowArrow && (
        <button
          className={`${styles.scrollButton} ${styles.right}`}
          onClick={() => scroll("right")}
        >
          <RightOutlined />
        </button>
      )}
    </div>
  );
};

export default ScrollableContainer;
